import angular from 'angular';
import { NoShowsController } from './NoShows.controller';
import template from './NoShows.template.html';

export const noShowsModule = angular
  .module('bit.components.NoShows', [])
  .component('bitNoShows', {
    template,
    controller: NoShowsController,
  });
